export var UnitTypeNames;
(function (UnitTypeNames) {
    UnitTypeNames["SquareMeter"] = "square_meter";
    UnitTypeNames["PerPiece"] = "per_piece";
    UnitTypeNames["SquareMeterWithBleed"] = "square_meter_with_bleed";
})(UnitTypeNames || (UnitTypeNames = {}));
